import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Context } from "../../../utils/context";
import Login_Green_Btn from "../../Common-Component/common_btn/login_green_btn/Login_Green_Btn";
import {
  ChangePasswordWL,
  emailOtpVerify,
} from "../../../utils/apis/myAccount/myAccount";

const Reset_Password = ({
  setSuccessModalShow,
  onHide,
  setFormType,
  setSuccessText,
  email,
  setShowSetNewPassword,
  ...props
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [errorOtp, setErrorOtp] = useState("");
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [iconCurrent, setIconCurrent] = useState(faEyeSlash);
  const { signin, setSignin, shimmerLoader, setShimmerLoader } =
    useContext(Context);
  const hideModalWithDelay = () => {
    setTimeout(() => {
      // window.location.href = "/vendor-page"; // Change window location to root route ("/")
      setModalShow(false);
    }, 3000); // Change the delay time as needed (2000 milliseconds = 2 seconds)
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    data.email = email;
    setPassword(data?.new_password);
    const verified = await emailOtpVerify(data);
    if (verified?.success) {
      const res = await ChangePasswordWL(data);
      if (res?.success) {
        onHide();
        setModalShow(true);
        setSuccessModalShow(true);
        setSuccessText("Password Updated Successfully!");

        setTimeout(() => {
          window.location.reload();
          setModalShow(false);
          setSuccessModalShow(false);
        }, 3000);
        setErrorOtp("");
      } else {
        setShimmerLoader(false);
        setError("otp", { message: res?.message });
      }
    } else {
      setError("otp", { message: verified?.message });
      setShimmerLoader(false);
    }
  };

  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    } else if (field === "current_password") {
      setShowPasswordCurrent(!showPasswordCurrent);
      setIconCurrent(showPasswordCurrent ? faEyeSlash : faEye);
    }
  };

  return (
    <div>
      <div className="logo_content">
        <div className="logo_holder">
          <img
            src="/assets/Image/Logo/Local-MandaiFinal-Logo.png"
            className="logo_img"
          />
        </div>
        <p className="modal_haeding">Set New Password</p>
      </div>

      <div className="form_holder">
        <Form>
          <Form.Group className="input_group">
            <div className="password-field-holder">
              <Form.Control
                type="otp"
                name="otp"
                maxLength={4}
                placeholder="OTP"
                {...register("otp", {
                  required: "OTP is required",
                })}
              />

              {/* <div className="eye-icon-holder ">
                          <FontAwesomeIcon
                            className="eye-icon"
                            icon="fa-solid fa-eye"
                          />
                        </div> */}
            </div>
            {errors?.otp && (
              <div className="mt-2">
                <sup className="text-danger  ">{errors?.otp?.message}</sup>
              </div>
            )}
          </Form.Group>

          <Form.Group className="input_group">
            <div className="password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="new_password"
                placeholder="Enter New Password"
                {...register("new_password", {
                  required: "New Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  validate: {
                    hasUpperCase: (value) =>
                      /[A-Z]/.test(value) ||
                      "Password must contain at least one uppercase letter",
                    hasLowerCase: (value) =>
                      /[a-z]/.test(value) ||
                      "Password must contain at least one lowercase letter",
                    hasNumber: (value) =>
                      /\d/.test(value) ||
                      "Password must contain at least one number",
                    hasSpecialChar: (value) =>
                      /[!@#$%^&*(),.?":{}|<>]/.test(value) ||
                      "Password must contain at least one special character",
                  },
                })}
              />
              {/* <InputGroup.Text id="basic-addon2"> */}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="eye"
                  onClick={() => togglePasswordVisibility("password")}
                />
              </div>

              {/* </InputGroup.Text> */}
            </div>
            {errors?.new_password && (
              <div className="mt-2">
                <sup className="text-danger  ">
                  {errors?.new_password?.message}
                </sup>
              </div>
            )}
          </Form.Group>

          <Form.Group className="input_group">
            <div className="password_holder">
              <Form.Control
                type={showPasswordOne ? "text" : "password"}
                name="confirm_password" // Ensure this name is unique
                placeholder="Confirm New Password"
                {...register("confirm_password", {
                  required: "Confirm Password is required",
                  validate: (value) =>
                    value === getValues("new_password") ||
                    "Passwords do not match",
                })}
              />
              {/* <InputGroup.Text id="basic-addon2"> */}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="icon"
                  onClick={() => togglePasswordVisibility("reenterPassword")}
                />
              </div>

              {/* </InputGroup.Text> */}
            </div>
            {errors?.confirm_password && (
              <div className="mt-2">
                <sup className="text-danger  ">
                  {errors?.confirm_password?.message}
                </sup>
              </div>
            )}
          </Form.Group>
          {/* {password && (
                      <PasswordChecklist
                        rules={["minLength", "specialChar", "number", "capital", "match"]}
                        minLength={8}
                        value={password}
                        valueAgain={passwordAgain}
                        onChange={(isValid) => { }}
                        style={{ fontSize: '10px', padding: '4px', margin: '0' }}
                      />
                    )} */}

          <div className="submit_btn_div">
            <Login_Green_Btn
              btn_name="Submit"
              onClick={handleSubmit(onSubmit)}
            />
          </div>

          <p
            className="create_acc_text"
            onClick={() => {
              setShowSetNewPassword(false);
            }}
          >
            Back
          </p>
        </Form>
      </div>
    </div>
  );
};

export default Reset_Password;
